export const printTemplatePrefix = 'printTemplate_$';
export const printTemplatePdfPrefix = 'printTemplate_pdf_$';
export const printTemplateReportPrefix = 'printTemplate_report_$';
